import { DatasetVersionControllerApi, DatesetControllerApi, UpdateDatasetOperationRequest } from './generated'
import { REQUEST_OPTIONS } from './_configs'

export const commonDatasetApiClient = new DatasetVersionControllerApi()
export const datasetApiClient = new DatesetControllerApi()

export const getDatasets = async () => {
  const response = await commonDatasetApiClient.getDatasetVersionsRaw(REQUEST_OPTIONS)
  const jsonData = await response.value()

  return jsonData
}

export const getDataset = async (datasetId: string) => {
  const response = await datasetApiClient.getDatasetDetailsRaw({ datasetId }, REQUEST_OPTIONS)
  const jsonData = await response.value()

  return jsonData
}

export const updateDataset = async (dataset: UpdateDatasetOperationRequest) => {
  return datasetApiClient.updateDataset(dataset, REQUEST_OPTIONS)
}
